import { useEffect } from 'react';

import { ONE_PAGE_DISPLAY_MODE, ONE_PAGE_STYLE_OPTIONS } from 'layouts/OnePagePreviewLayout/types';
import isEqual from 'lodash/isEqual';
import { useBusinessToolSessionStore, useBusinessToolStore } from 'store/useBusinessToolStore';
import {
  getBusinessPlan,
  getBusinessPlanChapters,
  getOnePageDisplayMode,
  getSetOnePageDisplayMode,
} from 'store/useBusinessToolStore/selectors';

import { useGetInitialValues } from 'components/BusinessToolForm/utils/form';

import { useOnePageStyleAvailability } from './useOnePageStyleAvailability';
import { useUpdateOnePageStyle } from './useUpdateOnePageStyle';

export const useOnePageExampleSwitch = () => {
  const onePageStyle = useBusinessToolStore(getBusinessPlan)?.metadata.onePageTemplateStyle;
  const formInitialValues = useGetInitialValues();

  const { getIsOnePageStyleAvailable } = useOnePageStyleAvailability();
  const { styleChangeHandler, isPending } = useUpdateOnePageStyle();
  const displayMode = useBusinessToolSessionStore(getOnePageDisplayMode);
  const setDisplayMode = useBusinessToolSessionStore(getSetOnePageDisplayMode);

  const isStyleAvailable = getIsOnePageStyleAvailable(onePageStyle);
  const chapters = useBusinessToolStore(getBusinessPlanChapters);

  const isExampleSwitchDisabled = isEqual(formInitialValues, chapters);

  const style = isStyleAvailable ? onePageStyle : ONE_PAGE_STYLE_OPTIONS.FIRST_STYLE;

  useEffect(() => {
    setDisplayMode(isExampleSwitchDisabled ? ONE_PAGE_DISPLAY_MODE.EXAMPLE : ONE_PAGE_DISPLAY_MODE.PROJECT);
  }, []);

  const changeDisplayModeHandler = async () => {
    if (!isStyleAvailable) {
      await styleChangeHandler(style);
    }

    setDisplayMode(
      displayMode === ONE_PAGE_DISPLAY_MODE.EXAMPLE ? ONE_PAGE_DISPLAY_MODE.PROJECT : ONE_PAGE_DISPLAY_MODE.EXAMPLE,
    );
  };

  return {
    changeDisplayModeHandler,
    isExampleSwitchDisabled,
    isPending,
  };
};
